export default class ResponseStreamHelper {
  async getBlobPdf(result) {
    const reader = result.body.getReader();
    const chunks = [];
    let isDone = false;
    while (!isDone) {
      const { done, value } = await reader.read();
      isDone = done;
      if (isDone) {
        break;
      }
      chunks.push(value);
    }
    return new Blob(chunks, { type: "application/pdf" });
  }
}
export const responseStreamHelper = new ResponseStreamHelper();
